import { render, staticRenderFns } from "./PlanesComponent.vue?vue&type=template&id=9ec6e73c&scoped=true"
import script from "./PlanesComponent.vue?vue&type=script&lang=js"
export * from "./PlanesComponent.vue?vue&type=script&lang=js"
import style0 from "./PlanesComponent.vue?vue&type=style&index=0&id=9ec6e73c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec6e73c",
  null
  
)

export default component.exports